module.exports = __webpack_public_path__ + "static/stepper-platinum-icon-d0473510c439c3a33bdaa42daa125db0.svg";